import React, { useState } from 'react';
import { FiRefreshCw, FiAlertCircle } from 'react-icons/fi';
import Modal from '../common/Modal';
import ButtonLoading from '../ButtonLoading';
import { userRequest } from '../../utils/requestMethods';

const SyncBalanceConfirmModal = ({ isOpen, onClose, schoolId, fundId, onSynced }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleConfirm = async () => {
    setLoading(true);
    setError('');
    try {
      await userRequest.post(`/schools/${schoolId}/funds/${fundId}/sync-balance`);
      onSynced?.();
      onClose();
    } catch (err) {
      setError(err?.response?.data?.message || 'Failed to sync balance. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Fix Fund Balance" icon={<FiRefreshCw className="text-indigo-600 text-lg" />}>
      <p className="text-sm text-gray-600 mb-4">
        This will rebuild the cached balance for this fund from its transaction ledger. Continue?
      </p>
      {error && (
        <div className="flex items-start gap-3 bg-red-50 border border-red-200 text-red-700 rounded-xl px-4 py-3 text-sm mb-4">
          <FiAlertCircle className="mt-0.5 shrink-0" />
          <span>{error}</span>
        </div>
      )}
      <div className="flex gap-3">
        <button
          type="button"
          onClick={onClose}
          disabled={loading}
          className="flex-1 py-2.5 text-sm font-medium text-gray-600 bg-gray-100 rounded-full hover:bg-gray-200 transition-colors disabled:opacity-50"
        >
          Cancel
        </button>
        {loading ? (
          <ButtonLoading styles="flex-1 text-white bg-indigo-500 font-medium rounded-full text-sm px-5 py-2.5 text-center" />
        ) : (
          <button
            type="button"
            onClick={handleConfirm}
            className="flex-1 py-2.5 text-sm font-medium text-white bg-indigo-600 rounded-full hover:bg-indigo-700 transition-colors"
          >
            Sync Balance
          </button>
        )}
      </div>
    </Modal>
  );
};

export default SyncBalanceConfirmModal;
